import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  href, 
  onClick,
  disabled = false,
  type = 'button',
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none';
  
  const variants = {
    primary: 'bg-primary hover:bg-blue-700 text-white focus:ring-primary shadow-lg hover:shadow-xl',
    secondary: 'bg-white hover:bg-gray-50 text-primary border-2 border-primary focus:ring-primary',
    outline: 'bg-transparent hover:bg-primary text-primary hover:text-white border-2 border-primary focus:ring-primary',
    ghost: 'bg-transparent hover:bg-gray-100 text-gray-700 hover:text-primary focus:ring-gray-300',
    dark: 'bg-secondary hover:bg-gray-800 text-white focus:ring-secondary',
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl',
  };

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  const buttonProps = {
    className: classes,
    onClick,
    disabled,
    type,
    ...props,
  };

  if (href) {
    // Check if it's an external link
    if (href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return (
        <motion.a
          href={href}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          {...buttonProps}
        >
          {children}
        </motion.a>
      );
    }
    
    // Check if it contains a hash (for scrolling to sections)
    if (href.includes('#')) {
      return (
        <motion.a
          href={href}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          {...buttonProps}
        >
          {children}
        </motion.a>
      );
    }
    
    // Use React Router Link for internal navigation
    return (
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Link
          to={href}
          className={classes}
          {...props}
        >
          {children}
        </Link>
      </motion.div>
    );
  }

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      {...buttonProps}
    >
      {children}
    </motion.button>
  );
};

export default Button;
